var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 6.11914L18 9.11914M6 21.1191L21 6.11914L18 3.11914L3 18.1191L6 21.1191ZM9 3.11914C9 3.64957 9.21071 4.15828 9.58579 4.53335C9.96086 4.90843 10.4696 5.11914 11 5.11914C10.4696 5.11914 9.96086 5.32985 9.58579 5.70493C9.21071 6.08 9 6.58871 9 7.11914C9 6.58871 8.78929 6.08 8.41421 5.70493C8.03914 5.32985 7.53043 5.11914 7 5.11914C7.53043 5.11914 8.03914 4.90843 8.41421 4.53335C8.78929 4.15828 9 3.64957 9 3.11914ZM19 13.1191C19 13.6496 19.2107 14.1583 19.5858 14.5334C19.9609 14.9084 20.4696 15.1191 21 15.1191C20.4696 15.1191 19.9609 15.3299 19.5858 15.7049C19.2107 16.08 19 16.5887 19 17.1191C19 16.5887 18.7893 16.08 18.4142 15.7049C18.0391 15.3299 17.5304 15.1191 17 15.1191C17.5304 15.1191 18.0391 14.9084 18.4142 14.5334C18.7893 14.1583 19 13.6496 19 13.1191Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWand);
export default __webpack_public_path__ + "static/media/wand.4d1a545c39625cff09c22214075e3bbf.svg";
export { ForwardRef as ReactComponent };